import React from "react";
import parse from "html-react-parser";

const Text = ({ options }: any) => {
  return <div>{parse(options || "")}</div>;
};

export default Text;
